import { cn } from '@/lib/utils';
const DATA: (BrandStatementCardProps & {
  id: string;
})[] = [{
  id: '1',
  title: 'Creative assets, done right',
  description: 'We keep it simple: Only great music and assets, effortless browsing, and safe licensing for any creative work. All backed by an ethical model that puts real artists first.'
}, {
  id: '2',
  title: "Curated for what's current",
  description: 'Shaped by culture and creator trends, with curated collections that help you land on great ideas, Uppbeat keeps your work feeling iconic, never generic.'
}, {
  id: '3',
  title: 'Hit publish with confidence',
  description: 'Every asset on Uppbeat is human-made and fully rights-cleared, so you can publish anywhere with confidence. No surprise claims, no murky licensing, and no ethical grey areas.'
}];
interface BrandStatementCardProps {
  description: string;
  title: string;
}
interface BrandStatementCardsProps {
  className?: string;
}
const BrandStatementCard = ({
  title,
  description
}: BrandStatementCardProps) => <div className="flex flex-col gap-1.5 rounded-lg border border-gray-150 border-solid bg-white p-6 dark:border-gray-800 dark:bg-black" data-sentry-component="BrandStatementCard" data-sentry-source-file="BrandStatementCards.tsx">
    <div className="font-heading font-semibold text-black text-lg leading-tight! tracking-tighter! md:text-base lg:text-lg 2xl:text-xl dark:text-white">
      {title}
    </div>
    <p className="text-black text-sm md:text-xs lg:text-sm 2xl:text-base dark:text-white">
      {description}
    </p>
  </div>;
export const BrandStatementCards = ({
  className = 'mb-16 md:mb-4 md:pt-8 lg:mb-7 lg:pt-10'
}: BrandStatementCardsProps) => <section className={cn('grid grid-cols-1 gap-4 px-0 md:grid-cols-3 md:px-container lg:gap-5', className)} data-sentry-component="BrandStatementCards" data-sentry-source-file="BrandStatementCards.tsx">
    {DATA.map(item => <BrandStatementCard description={item.description} key={item.id} title={item.title} />)}
  </section>;